<div class="container">
  <h1>BillPay info</h1>
  <hr/>
  <ul class="nav nav-tabs" id="dealTabs" role="tablist">
    <li class="nav-item">
      <a
        class="nav-link active bg-light"
        id="active-tab"
        data-toggle="tab"
        routerLink="active"
        role="tab"
        aria-controls="active"
        aria-selected="true"
        >Back</a
      >
    </li>
  </ul>
  <br />
  <div class="float-right my-2">
    <button
      type="button"
      class="btn btn-outline-success btn-block"
      data-toggle="modal"
      data-target="#billPayCreateFrom"
      data-whatever="@mdo"
    >
      Create
    </button>
  </div>
  <br />
  <table class="table table-hover" id="billPayTable">
      <thead class="thead-light">
        <tr>
          <th scope="col" style="width: 10%" class="hide">#</th>
          <th scope="col" style="width: 25%">name</th>
          <th scope="col" style="width: 25%">address</th>
          <th scope="col" style="width: 10%">account</th>
          <th scope="col" style="width: 10%">routing</th>
          <th scope="col" style="width: 10%">phone</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let billpay of billpayList; index as i">
          <tr>
            <th scopr="row" class="hide">{{ ('000' + billpay.id).slice(-4) }}</th>
            <td>
              {{ billpay.name }}
            </td>
            <td>
              {{ billpay.address }}
            </td>
            <td>
              {{ billpay.account }}
            </td>
            <td>
              {{ billpay.routing }}
            </td>
            <td>
              {{ billpay.phone }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  <div
    class="modal fade"
    id="billPayCreateFrom"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">BillPay Create Form</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label for="name">Name:</label>
              <input type="text" class="form-control" id="name" name="name" [(ngModel)]="name"/>
            </div>
            <div class="form-group">
              <label for="address">Address:</label>
              <input type="text" class="form-control" id="address" name="address" [(ngModel)]="address"/>
            </div>
            <div class="form-group">
              <label for="account">Account:</label>
              <input type="text" class="form-control" id="account" name="account" [(ngModel)]="account"/>
            </div>
            <div class="form-group">
              <label for="routing">Routing:</label>
              <input type="text" class="form-control" id="routing" name="routing" [(ngModel)]="routing"/>
            </div>
            <div class="form-group">
              <label for="phone">Phone:</label>
              <input type="text" class="form-control" id="phone" name="phone" [(ngModel)]="phone"/>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  (click) = "create()"
                >
                  Add
                </button>
              </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
